var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"all-about"},[_c('production'),_c('div',{staticClass:"delivery-wrapper"},[_c('description',{staticClass:"desktop-description"}),(_vm.currentProduct && _vm.currentProduct.buyTogether.data.length)?_c('delivery-payment',{staticClass:"mobile-delivery"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }